import {
  ADMIN_PORTAL_PREFIX,
  APPRENANT_PORTAL_PREFIX,
  FORMATEUR_PORTAL_PREFIX,
  ROLE_ADMIN,
  ROLE_APPRENANT,
  ROLE_FORMATEUR,
  ROLE_MODERATEUR,
  ROLE_PARTENAIRE,
  ROLE_AMBASSADEUR,
  PARTENAIRE_PORTAL_PREFIX,
  AMBASSADEUR_PORTAL_PREFIX,
} from '../constants/roles';
import { resolveModerateurHomePath } from '../constants/adminModules';
import { getPendingFiliereSubscriptionId } from './pendingFiliereSubscription';

/** Accès au portail direction (administrateur ou modérateur délégué). */
export function canAccessAdminPortal(role) {
  return role === ROLE_ADMIN || role === ROLE_MODERATEUR;
}

/** Accès au portail apprenant. */
export function canAccessApprenantPortal(role) {
  return role === ROLE_APPRENANT;
}

/** Accès au portail formateur. */
export function canAccessFormateurPortal(role) {
  return role === ROLE_FORMATEUR;
}

/** Accès au portail partenaire institutionnel (parrainage & wallet). */
export function canAccessPartenairePortal(role) {
  return role === ROLE_PARTENAIRE;
}

/** Accès au portail ambassadeur (publicité, parrainage & wallet). */
export function canAccessAmbassadeurPortal(role) {
  return role === ROLE_AMBASSADEUR;
}

/** Chemin après connexion / inscription (formation en attente → paiement des frais). */
export function resolvePostAuthPath(role, user) {
  if (role === ROLE_APPRENANT) {
    const pendingId = getPendingFiliereSubscriptionId();
    if (pendingId) {
      return `${APPRENANT_PORTAL_PREFIX}/formations/subscribe/${pendingId}`;
    }
  }
  return getHomePathForRole(role, user);
}

/** Chemin d’accueil après connexion selon le rôle. */
export function getHomePathForRole(role, user) {
  if (canAccessAdminPortal(role)) {
    if (role === ROLE_MODERATEUR) {
      return resolveModerateurHomePath(user);
    }
    return `${ADMIN_PORTAL_PREFIX}/dashboard`;
  }
  if (canAccessFormateurPortal(role)) {
    if (user?.mustCompleteProfile) {
      return `${FORMATEUR_PORTAL_PREFIX}/profil`;
    }
    if (user?.mustChangePassword) {
      return `${FORMATEUR_PORTAL_PREFIX}/profil`;
    }
    return `${FORMATEUR_PORTAL_PREFIX}`;
  }
  if (canAccessAmbassadeurPortal(role)) {
    if (user?.mustCompleteProfile || user?.mustChangePassword) {
      return `${AMBASSADEUR_PORTAL_PREFIX}/profil`;
    }
    return `${AMBASSADEUR_PORTAL_PREFIX}`;
  }
  if (canAccessPartenairePortal(role)) {
    return `${PARTENAIRE_PORTAL_PREFIX}/parrainage`;
  }
  if (canAccessApprenantPortal(role)) {
    return `${APPRENANT_PORTAL_PREFIX}`;
  }
  return '/';
}

/** Redirection si l’utilisateur tente le mauvais portail. */
export function getPortalRedirectForPath(pathname, role, user) {
  if (pathname.startsWith(ADMIN_PORTAL_PREFIX) && !canAccessAdminPortal(role)) {
    return getHomePathForRole(role, user);
  }
  if (pathname.startsWith(APPRENANT_PORTAL_PREFIX) && !canAccessApprenantPortal(role)) {
    return getHomePathForRole(role, user);
  }
  if (pathname.startsWith(FORMATEUR_PORTAL_PREFIX) && !canAccessFormateurPortal(role)) {
    return getHomePathForRole(role, user);
  }
  if (pathname.startsWith(PARTENAIRE_PORTAL_PREFIX) && !canAccessPartenairePortal(role)) {
    return getHomePathForRole(role, user);
  }
  if (pathname.startsWith(AMBASSADEUR_PORTAL_PREFIX) && !canAccessAmbassadeurPortal(role)) {
    return getHomePathForRole(role, user);
  }
  return null;
}
